/**
 * ScenarioAnalysisConstants: constants used by the scenario analysis section.
 */
export class ScenarioAnalysisConstants {
	public static readonly SCENARIO_ANALYSIS_CATEGORIES = ['Equity', 'Fixed Income', 'Multi Asset', 'Alternative', 'Other'];

	public static readonly SCENARIO_ANALYSIS_CATEGORIES_RAW_VALUES = ['equity', 'fixedIncome', 'allocation', 'alternative', 'other'];

	public static readonly ScenarioAnalysisConfigCodes = ['AC_SPX_DN', 'AC_VIX_UP', 'AC_USHY_UP', 'AC_CPI_UP', 'AC_10Y_UP', 'AC_OIL_UP'];

	public static readonly MISC = {
		CHART_ID: 'category_'
	};

	public static readonly DcrKeys = [
		'SCENARIO_ANALYSIS_DISCLOSURE',
		'SCENARIO_ANALYSIS_CHART_TITLE',
		'SCENARIO_ANALYSIS_CHART_SUB_TITLE',
		'SCENARIO_ANALYSIS_LEGEND_EQUITY',
		'SCENARIO_ANALYSIS_LEGEND_FIXED_INCOME',
		'SCENARIO_ANALYSIS_LEGEND_MULTI_ASSET',
		'SCENARIO_ANALYSIS_LEGEND_ALTERNATIVES',
		'ALL_PORTFOLIOS'
	];

	public static readonly SERIES = [
		{
			name: 'Equity',
			data: [1, 2, 3, 4, 5, 2],
			stack: 'M. Williams Moderate'
		},
		{
			name: 'Fixed Income',
			data: [0, -2, 2, 4, -5, -1],
			stack: 'M. Williams Moderate'
		},
		{
			name: 'Multi Asset',
			data: [3, 4, -3, 1, 5, 4],
			stack: 'M. Williams Moderate'
		},
		{
			name: 'Alternatives',
			data: [3, 4, -3, 1, 5, -2],
			stack: 'M. Williams Moderate'
		},
		{
			name: 'Equity',
			data: [1, -2, 0, 1, 2, 0],
			stack: 'BlackRock'
		},
		{
			name: 'Fixed Income',
			data: [0, -2, 2, 4, -5, 1],
			stack: 'BlackRock'
		},
		{
			name: 'Multi Asset',
			data: [3, 4, -3, 1, 5, 3],
			stack: 'BlackRock'
		},
		{
			name: 'Alternatives',
			data: [1, -1, 0, 1, 5, 0],
			stack: 'BlackRock'
		},
		{
			name: 'Equity',
			data: [1, -2, 0, 1, 2, 0],
			stack: 'Benchmark'
		},
		{
			name: 'Fixed Income',
			data: [0, -2, 2, 4, -5, 1],
			stack: 'Benchmark'
		},
		{
			name: 'Multi Asset',
			data: [5, 1, 3, -1, 2, 1],
			stack: 'Benchmark'
		},
		{
			name: 'Alternatives',
			data: [1, -4, 0, 4, -2, 4],
			stack: 'Benchmark'
		}
	];

	public static readonly SVG_ASSETS = {
		COST: `<svg width="23px" height="24px" viewBox="0 0 23 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
		<!-- Generator: sketchtool 51.3 (57544) - http://www.bohemiancoding.com/sketch -->
		<title>F224CF5B-4DD5-4959-AA30-46F149E0CE9D</title>
		<desc>Created with sketchtool.</desc>
		<defs></defs>
		<g id="Desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
			<g id="2P-Overview-SS" transform="translate(-341.000000, -1197.000000)">
				<g id="sections-/-Snapshot-/-2P" transform="translate(330.000000, 655.000000)">
					<g id="Group-2" transform="translate(10.000000, 541.994485)">
						<g id="icon-cost">
							<g id="fees-dollar" transform="translate(2.000000, 0.000000)">
							<path d="M19.6693269,10.3331907 L17.7086538,1.61835405 C17.6347491,1.27629133 17.3063177,1.05219172 16.9615385,1.10857251 L8.3475,2.51047173 C8.14535581,2.54426558
							7.97057576,2.67072765 7.875,2.85234903 L7.45298077,3.64129664 L7.42875,3.68377844 L0.121153846,15.2671477 C-0.0684938923,15.5727184 0.0213557245,15.9741844 0.323076923,
							16.1693801 L10.8897115,23.184945 C11.0374776,23.2819588 11.2180461,23.3151867 11.3905794,23.2771139 C11.5631128,23.2390411 11.7130359,23.1328839 11.8064423,22.9826508
							L19.0756731,11.4721074 L19.1019231,11.4276027 L19.6834615,10.3271219 L19.6693269,10.3331907 Z" id="Shape" stroke="#000000" stroke-width="0.75" stroke-linecap="round"
							stroke-linejoin="round"></path> <path d="M14.6091346,3.94878371 C13.9104808,3.98519667 13.2542308,4.55566649 13.2582692,5.50847245 C13.2588674,5.58394796 13.2732384,
							5.65867754 13.3006731,5.72897319 C13.5065972,6.35180574 14.0980096,6.76383599 14.7525,6.74044449 C15.4572115,6.70403153 16.1215385,6.13356171 16.0993269,5.16052632
							C16.0972634,5.08481955 16.0815287,5.01011331 16.0528846,4.94002558 C15.8428261,4.32575105 15.2569038,3.92100882 14.6091346,3.94271488" id="Shape" stroke="#000000" stroke-
							width="0.75" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M20.3942308,0.171950114 C20.7257978,0.81768442 20.9249063,1.5234113 20.9798077,2.24748919
							C21.0619445,3.10455748 20.7293665,3.94918856 20.0852885,4.51925369 C19.0756731,5.38709605 17.9388462,5.29201775 16.9272115,5.20705416 C16.1417308,5.14029705 15.3986538,
							5.07758583 14.6838462,5.42148607" id="Shape" stroke="#000000" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M12.4546154,10.0216575
							C13.2167745,10.5167998 13.8044337,11.2392794 14.1346154,12.0870818 C13.6075962,12.2489172 13.0886538,12.4026609 12.5575962,12.5503357 C12.4223249,12.032559 12.1064234,
							11.5804416 11.6671154,11.2758819 L10.7200962,12.8052264 C11.5277885,13.7175735 12.4404808,14.8787426 11.5883654,16.2442288 C10.73625,17.609715 9.21778846,17.6238756
							8.07692308,16.9623734 L7.64076923,17.6602886 L6.93403846,17.2172642 L7.37019231,16.519349 C6.51639828,15.9625519 5.87587092,15.1326137 5.55288462,14.1646438 C6.10211538,
							14.0291067 6.66548077,13.8895236 7.21067308,13.7398259 C7.33525623,14.3399524 7.67055662,14.8754094 8.15567308,15.248941 L9.19961538,13.5739446 C8.28692308,12.5907945
							7.56403846,11.551002 8.36365385,10.2725023 C9.16326923,8.99400265 10.7120192,9.01625502 11.7458654,9.59481659 L12.1497115,8.93533732 L12.8463462,9.37229291 L12.4546154,
							10.0216575 Z M10.9886538,10.8207198 C10.6211538,10.6447238 10.15875,10.6609073 9.89625,11.0816794 C9.63375,11.5024515 9.78721154,11.8524205 10.1244231,12.2084584
							L10.9886538,10.8207198 Z M8.86442308,15.7000571 C9.05642963,15.8263206 9.29301183,15.8647195 9.51498915,15.8056484 C9.73696647,15.7465773 9.92334407,15.5956232 10.0275,
							15.3905469 C10.3021154,14.9495454 10.1304808,14.5651863 9.80740385,14.188919 L8.86442308,15.7000571 Z" id="Shape" fill="#000000" fill-rule="nonzero"></path>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>`,
		PERFORMANCE: `<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
		<!-- Generator: Sketch 51.3 (57544) - http://www.bohemiancoding.com/sketch -->
		<title>icon-performance</title>
		<desc>Created with Sketch.</desc>
		<defs></defs>
		<g id="icon-performance" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
			<rect id="Rectangle-path" stroke="#000000" stroke-width="0.75" x="19.375" y="3.375" width="3.25" height="17.25" rx="0.75"></rect>
			<rect id="Rectangle-path-Copy-3" stroke="#000000" stroke-width="0.75" x="1.375" y="13.375" width="3.25" height="7.25" rx="0.75"></rect>
			<rect id="Rectangle-path-Copy-4" stroke="#000000" stroke-width="0.75" x="7.375" y="6.375" width="3.25" height="14.25" rx="0.75"></rect>
			<rect id="Rectangle-path-Copy-5" stroke="#000000" stroke-width="0.75" fill="#000000" x="13.375" y="9.375" width="3.25" height="11.25" rx="0.75"></rect>
		</g>
	</svg>`,
		RISK: `<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
		<!-- Generator: Sketch 51.3 (57544) - http://www.bohemiancoding.com/sketch -->
		<title>icon-risk</title>
		<desc>Created with Sketch.</desc>
		<defs></defs>
		<g id="icon-risk" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
			<g id="Group" transform="translate(0.000000, 6.000000)" fill-rule="nonzero" stroke="#000000">
			<path d="M5.21044962,2.71706224 C2.41066739,4.76698474 0.662356892,7.97564515 0.510740118,11.5 L5.51905896,11.5 C5.65917713,9.66735837 6.56446912,8.0021385 7.9888919,
			6.88472566 L5.21044962,2.71706224 Z" id="Combined-Shape"></path> <path d="M18.480941,11.5 L23.4892599,11.5 C23.3376431,7.97564515 21.5893326,4.76698474 18.7895504,
			2.71706224 L16.0111081,6.88472566 C17.4355309,8.0021385 18.3408229,9.66735837 18.480941,11.5 Z" id="Combined-Shape"></path> <path d="M18.4810552,11.5 L23.4893258,11.5
			C23.2275476,5.38069188 18.1837471,0.5 12,0.5 C5.81625285,0.5 0.77245237,5.38069188 0.510674186,11.5 L5.51894482,11.5 C5.77425725,8.14377614 8.57838512,5.5 12,5.5
			C15.4216149,5.5 18.2257427,8.14377614 18.4810552,11.5 Z" id="Combined-Shape-Copy"></path>
			</g>
			<path d="M11.6943516,16.9979111 C11.6943516,16.9799271 11.6943516,16.9649405 11.6862244,16.9484552 L14.9763803,14.9312554 L11.5128444,16.5528083 C11.2940547,16.3036252
			10.9452046,16.2640458 10.6852589,16.4589132 C10.4253132,16.6537805 10.329207,17.0269198 10.4572638,17.3441204 C10.5853207,17.6613211 10.9006253,17.8311431 11.2052687,
			17.7469933 C11.5099121,17.6628435 11.716074,17.3489798 11.6943516,17.0024071 L11.6943516,16.9979111 Z" id="Shape-Copy" stroke="#000000" stroke-width="0.75"
			fill="#000000" fill-rule="nonzero" transform="translate(12.688642, 16.349836) rotate(-29.000000) translate(-12.688642, -16.349836) "></path>
		</g>
	</svg>`
	};
}
